import type { State } from '../types.tsx';

export const getProductUsageStartTimestamp = (state: State): string | undefined =>
	state.productUsageStartTimestamp;
